<template>
  <div class="purchase"><router-view></router-view></div>
</template>

<script>
import 'lib-flexible'
import { setCurEnv, getEnv } from '@esign/esign-plugin/lib/esign-jssdk'
import Vue from 'vue'
import tsignData from '@tsign/tsigndata-sdk-js-for-statistics'

export default {
  name: 'Purchase',
  async beforeCreate() {
    const curEnv = this.$route.query.client || (await getEnv())
    tsignData.registerPage({
      PlatformType: curEnv,
    })
    setCurEnv(curEnv)
    Vue.prototype.$Http = this.$EHttp // 移动端购买统一用EHttp
  },
}
</script>

<style lang="less" scoped>
.purchase {
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background: #f5f5f5;
}
</style>
<style>
a {
  font-size: 32px;
}
</style>
